import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";
import { Col, Image, Row } from "react-bootstrap";
import Truncate from "react-truncate";
import dateFormat from 'dateformat';
import DOMPurify from 'dompurify';
import LockIcon from 'components/lockIcon';

import { searchAssets, invalidateAssetsSearch } from 'actions/assets';
import { searchCollections,  invalidateCollectionsSearch } from "actions/collections";
import { searchStreams, invalidateStreamsSearch } from "actions/streams";
import InfiniteScroll from "react-infinite-scroller";
import FileService from "services/file.service";

import paperfliteLogo from 'images/logo-dark.png';

import styles from './search.module.scss';
import cx from "classnames";
import _ from "lodash";
import { deselectAsset, selectAsset, selectCollection } from "actions/selection";
import GenerateLink from "components/generateLink";
import { CollectionNode, MyStreams, StreamNode } from "pages/contentLibraryOld";
import { trackAdoptionMetricsForContentSearchedEvent, trackAdoptionMetricsForAssetDetailViewedEvent, trackAdoptionMetricsForStreamDetailViewedEvent, trackAdoptionMetricsForCollectionDetailViewedEvent } from "actions/adoption";


export default function SearchView(props) {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const webAppUrl = process.env.REACT_APP_WEBAPP_URL;

  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState("assets");
  const [enableSearch, setEnableSearch] = useState(false);
  const [searching, setSearching] = useState(false);
  const [generateLink, setGenerateLink] = useState(false);
  const [content, setContent] = useState(null);
  const [contentType, setContentType] = useState("asset");

  const assets = useSelector((state) => _.get(state, 'search.items'))

  const onQueryChange = (event) => {
    const value = event.target.value;
    setQuery(value);

    if(_.size(value) == 0){
      setEnableSearch(false);
      props.handleShowTabs(true);
    }
  }

  const handleSubmit = (event) => {
    setEnableSearch(true);
    props.handleShowTabs(false);
    if(event){
      event.preventDefault();
    }
    if(query != ""){
      setSearching(true);
      if(filter === "assets"){
        dispatch(searchAssets(query, 0, 20));
        dispatch(trackAdoptionMetricsForContentSearchedEvent("Content Searched", "Content Library", query, "Assets", "", ""));
      }else if(filter === "collections"){
        dispatch(searchCollections(query, true, 0, 12, false));
        dispatch(trackAdoptionMetricsForContentSearchedEvent("Content Searched", "Content Library", query, "Collections", "", ""));
      }else if(filter === "streams"){
        dispatch(searchStreams(query, true, 0, 12, false));
        dispatch(trackAdoptionMetricsForContentSearchedEvent("Content Searched", "Content Library", query, "Streams", "", ""));
      }
    }else{
     handleDisableItems();
    }
  }

  const onFilterChange = (value) => {
    setFilter(value);
    if(query != ""){
      setSearching(true);
      if(value === "assets"){
        dispatch(searchAssets(query, 0, 20));
        dispatch(trackAdoptionMetricsForContentSearchedEvent("Content Searched", "Content Library", query, "Assets", "", ""));
      }else if(value === "collections"){
        dispatch(searchCollections(query, true, 0, 12, false));
        dispatch(trackAdoptionMetricsForContentSearchedEvent("Content Searched", "Content Library", query, "Collections", "", ""));
      }else if(value === "streams"){
        dispatch(searchStreams(query, true, 0, 12, false));
        dispatch(trackAdoptionMetricsForContentSearchedEvent("Content Searched", "Content Library", query, "Streams", "", ""));
      }
    }else{
      handleDisableItems();
    }
  }

  const handleDisableItems = () => {
    setSearching(false);
    dispatch(invalidateAssetsSearch());
    dispatch(invalidateStreamsSearch());
    dispatch(invalidateCollectionsSearch());
  }

  const showGenerateLink = (type, content) => {
    setContent(content);
    setContentType(type);
    setGenerateLink(true);
  }

  const renderFilterGroup = () => {
    return (
      <div className={styles.toolbar}>
        <div className={cx(styles.filterHeading)}>
          <div> Search for: </div>
        </div>
        <div className={cx(styles.filter)}>
          <div className={cx(styles.link, { [styles.active]: filter == 'assets' })}
            onClick={() => onFilterChange('assets')}>
            Assets
          </div>
        </div>
        <div className={cx(styles.filter)}>
          <div className={cx(styles.link, { [styles.active]: filter == 'collections' })}
            onClick={() => onFilterChange('collections')}>
            Collections
          </div>
        </div>
        <div className={cx(styles.filter)}>
          <div className={cx(styles.link, { [styles.active]: filter == 'streams' })}
            onClick={() => onFilterChange('streams')}>
            Streams
          </div>
        </div>
      </div>
    );
  }


  return (
    <div className={styles.container}>
      {content && <GenerateLink entity={content} type={contentType} show={generateLink} setShow={setGenerateLink} />}
      <Col
        sm={12}
        className={styles.column}
      >
        <Row className={styles.top}>
          <Col sm={12} className={cx(styles.searchBar, styles.column)}>
            <form
              onSubmit={handleSubmit}
            >
              <Col sm={11}
                className={styles.column}
              >
                <div className={styles.search}>
                  <div className={styles.searchContent}>
                    <span className={cx("paperflite-search", styles.searchIcon)}></span>
                    <label>
                      <input
                        type="text"
                        value={query}
                        placeholder="Type here to search"
                        onChange={onQueryChange}
                      />
                    </label>
                  </div>
                </div>
              </Col>
            </form>
          </Col>
        </Row>
      </Col>
      {enableSearch && renderFilterGroup()}
      {enableSearch && 
      <SearchResult filter = {filter} searching={searching} webAppUrl={webAppUrl} attachAssets={props.attachAssets} showGenerateLink={showGenerateLink}/>
      }
    </div>
  );
}

function SearchResult({filter, searching, webAppUrl, attachAssets, showGenerateLink}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const query = useSelector((state) => _.get(state, 'assets.search.query') || "");
  const loading = useSelector((state) => _.get(state, `${filter}.search.searching`) || false);
  const items = useSelector((state) => _.get(state, `${filter}.search.items`) || []);
  const currentPage = useSelector((state) => _.get(state, `${filter}.search.pagination.current`) || 0);
  const totalPages = useSelector((state) => _.get(state, `${filter}.search.pagination.totalPages`) || 0);
  const assets = useSelector((state) => _.get(state, `application.assets`) || []);

  const [selectedAssets, setSelectedAssets] = useState([]);

  useEffect(() => {
    setSelectedAssets(assets);
  }, [assets])
  
  const initialLoading = loading && items.length === 0;

  const loadMoreItems = () => {
    if (loading) {
      return;
    }

    if(filter === "assets"){
      dispatch(searchAssets(query, currentPage + 1, 20));
    }else if(filter === "collections"){
      dispatch(searchCollections(query, true, currentPage + 1, 12, false));
    }else if(filter === "streams"){
      dispatch(searchStreams(query, true, currentPage + 1, 12, false));
    }
  }

  const handleAssetClick = (selectedAsset) => {
    if(selectedAssets.includes(selectedAsset)){
      dispatch(deselectAsset(selectedAsset));
      const filteredAssets = selectedAssets.filter(asset => asset.id != selectedAsset.id);
      setSelectedAssets(filteredAssets);
    }else{
      setSelectedAssets([...selectedAssets, selectedAsset]);
      const allAssets = [...selectedAssets, selectedAsset];
      allAssets.map(asset => dispatch(selectAsset(asset)));
    }
  }

  const handleAttachItems = () => {
    history.push("/attachAssets");
  }

  const isSelected = (asset) => {
    return assets.map(item => item.id).includes(asset.id);
  }

  const renderCollection = () => { 
    const filteredCollections=items.filter((item)=>!item.dealRoom && !item.internal)
    if(_.size(filteredCollections) === 0 && !loading){
      return <div className={styles.empty}>No results found</div>
    } else{
      return filteredCollections.map(item => <SearchCollectionNode key={item.id} collection={item} webAppUrl={webAppUrl} attachAssets={attachAssets} handleContentClick={showGenerateLink}/>)
    }
  }

  return (
    <div>
    <div className={styles.searchResults}>
      {initialLoading &&
        <div className={cx(styles.loading, styles.initial)}>Searching {filter}...</div>
      }
      <InfiniteScroll
        pageStart={0}
        initialLoad={false}
        hasMore={currentPage < totalPages}
        loadMore={() => { loadMoreItems() }}
        useWindow={false}
        threshold={150}
      >

        {!searching && !loading && items.length == 0 &&
        <div className={styles.empty}>What's on your mind?</div>
        }

        {!loading && items.length == 0 && searching &&
          <div className={styles.empty}>No results found</div>
        }

        {filter === "assets" && _.size(items) > 0 &&
        items.map(item => <SearchAssetNode key={item.id} asset={item} handleAssetClick={handleAssetClick} isSelected={isSelected} webAppUrl={webAppUrl} attachAssets={attachAssets} showGenerateLink={showGenerateLink}/>)
        }

        {filter === "streams" && _.size(items) > 0 &&
        items.map(item => <SearchStreamNode key={item.id} stream={item} webAppUrl={webAppUrl} attachAssets={attachAssets} handleContentClick={showGenerateLink}/>)
        }

        {filter === "collections" && _.size(items) > 0 && 
        renderCollection()
        } 
        

        {!initialLoading && loading &&
          <div className={styles.loading}>Loading more...</div>
        }
      </InfiniteScroll>
    </div>
    {_.size(assets) > 0 &&
     <div className={styles.selectedItems} onClick={() => handleAttachItems()}>
          <span className={styles.selectedAssetsCount}>SELECTED ASSETS ({_.size(assets)})</span>
     </div>
    }
    </div>
  );
}

function SearchAssetNode({ asset, handleAssetClick, isSelected, webAppUrl, attachAssets, showGenerateLink}) {
  const dispatch = useDispatch();

  const icon = _.get(asset, 'icon.thumbnail') || "/images/default_asset.jpg"

  const handleClick = () => {
    if (!_.get(asset, "settings.share", true)) {
      return;
    }
    
    if (attachAssets) {
      handleAssetClick(asset);
    } else {
      showGenerateLink("asset", asset);
    }
  };
  

  return (
    <div className={cx(styles.row, styles.assetRow)} key={asset.id}
    >
      {!_.get(asset, 'settings.share', false) && (
      <span className={styles.lockIcon}>
        <LockIcon />
        </span>
      )}
      <div className={styles.assetIcon}>
      {!_.get(asset, 'settings.share', false) && (
      <span className={styles.lockIcon}><LockIcon /></span>
      )}
      {asset.settings && !asset.settings.share && <span className={styles.lockIcon}><LockIcon /></span>}
      
      <Image className={cx(styles.assetIcon,   styles.attachAssetIcon, {
        [styles.selectedAsset] : isSelected(asset)})} src={icon} width={36} height={36} 
        onClick={handleClick}
      />
      </div>
      <div className={cx(styles.details, styles.attachDetails )}>
        <div className={styles.name}>
          <Truncate lines={1}>{_.get(asset, "name", "")}</Truncate>
        </div>
        <div className={styles.meta}>
          {_.get(asset, "metadata.pages")} Pages | {FileService.formatSize(_.get(asset, "metadata.content_length", 0))} | {FileService.fileType(asset.metadata)}
        </div>
        <div className={styles.updatedAsset}>
          Last Updated on {dateFormat(asset.modifiedDate, 'dd mmm yyyy')}
        </div>
          <a href = {`${webAppUrl}/assets/${asset.id}?source=chrome_extension`} target = "_blank" className={styles.previewAsset}
          onClick={() => dispatch(trackAdoptionMetricsForAssetDetailViewedEvent("Asset Detail Viewed", "Content Library", FileService.fileType(_.get(asset, "metadata"))))}
          >
          <i className={cx(styles.previewIcon , "paperflite-left-arrow")}></i>
          <span className={styles.previewText}>OPEN</span>
          </a>
      </div>
    </div>
  );
}

function SearchStreamNode({stream, webAppUrl, attachAssets, handleContentClick}){
  const dispatch = useDispatch();

  const icon = _.get(stream, 'banner.background.full') || "/images/default_asset.jpg"

  return(
    <div className={cx(styles.row)} key={stream.id}>

      {!attachAssets && (
        <StreamNode stream={stream} attachAssets={attachAssets} webAppUrl={webAppUrl} handleContentClick={handleContentClick}/>
      )}

      {attachAssets && (
      <div className={styles.stream}>
      <Image className={styles.streamIcon} src={icon} width={36} height={36} />
      <div className={cx(styles.details, {
         [styles.attachDetails] : attachAssets
      })}>
        <div className={styles.name}>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(stream.name)}}></div>
        </div>
        <div className={styles.meta}>
        {_.get(stream, "groupCount", "")} Groups | {_.get(stream, "assetsCount", "")} Assets
        </div>
        <div className={styles.updatedStream}>
          Last Updated {dateFormat(stream.modifiedDate, 'dd mmm yyyy')}
        </div>
        <a href = {`${webAppUrl}/streams/${stream.id}?source=chrome_extension`} target = "_blank" className={styles.previewAsset}
        onClick={() =>  dispatch(trackAdoptionMetricsForStreamDetailViewedEvent("Stream Detail Viewed", _.get(stream, "name", "")))}
        >
          <i className={cx(styles.previewIcon , "paperflite-left-arrow")}></i>
          <span className={styles.previewText}>OPEN</span>
        </a>
      </div>
      </div> 
      )}
    </div>
  )
}

function SearchCollectionNode({collection, webAppUrl, attachAssets, handleContentClick}){
  const dispatch = useDispatch();
  const history = useHistory();

  const icon = _.get(collection, 'icon.full') || "/images/default_asset.jpg"

  const handleCollectionClick = () => {
    dispatch(selectCollection(collection));
    history.push("/attachAssets");
  }

  return(
    <div className={cx(styles.row)} key={collection.id}>

      {!attachAssets && (
        <CollectionNode content={collection} attachAssets={attachAssets} webAppUrl={webAppUrl} handleContentClick={handleContentClick}/>
      )}

      {attachAssets && (
      <div className={styles.collection}>
      <Image className={cx(styles.collectionIcon, styles.attachCollectionIcon, {
      })} src={icon} width={36} height={36} onClick={() =>  attachAssets ? handleCollectionClick() : handleContentClick(collection,  "collection")}/>
      <div className={cx(styles.details, {
         [styles.attachDetails] : attachAssets
      })}>
        <div className={styles.name}>
          <Truncate lines={1}>{collection.name}</Truncate>
        </div>
        <div className={styles.meta}>
          {_.get(collection, "assetsCount", "")} Assets
        </div>
        <div className={styles.updatedCollection}>
          Last Updated {dateFormat(collection.modifiedDate, 'dd mmm yyyy')}
        </div>
        <a href = {`${webAppUrl}/collections/${collection.id}?source=chrome_extension`} target = "_blank" className={styles.previewAsset}
        onClick={() => dispatch(trackAdoptionMetricsForCollectionDetailViewedEvent("Collection Detail Viewed", _.get(collection, "name", "")))}
        >
          <i className={cx(styles.previewIcon , "paperflite-left-arrow")}></i>
          <span className={styles.previewText}>OPEN</span>
        </a>
      </div> 
      </div>
      )}
    </div>
  )
}
